__turbopack_context__.v({
  "appNumber": "BrandCard-module__gSqsyW__appNumber",
  "brandName": "BrandCard-module__gSqsyW__brandName",
  "card": "BrandCard-module__gSqsyW__card",
  "compact": "BrandCard-module__gSqsyW__compact",
  "descText": "BrandCard-module__gSqsyW__descText",
  "description": "BrandCard-module__gSqsyW__description",
  "detailRow": "BrandCard-module__gSqsyW__detailRow",
  "details": "BrandCard-module__gSqsyW__details",
  "header": "BrandCard-module__gSqsyW__header",
  "label": "BrandCard-module__gSqsyW__label",
  "logo": "BrandCard-module__gSqsyW__logo",
  "logoContainer": "BrandCard-module__gSqsyW__logoContainer",
  "nameSection": "BrandCard-module__gSqsyW__nameSection",
  "placeholderLogo": "BrandCard-module__gSqsyW__placeholderLogo",
  "value": "BrandCard-module__gSqsyW__value",
});
